import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../helpers/JsonMappedModel";
import User from "./User";
import Image from "../image/Image";
var _attributes = /*#__PURE__*/new WeakMap();
export default class UserIdVerification extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [UserIdVerification.id_attribute_name]: null,
      [UserIdVerification.user_attribute_name]: User,
      [UserIdVerification.full_name_attribute_name]: null,
      [UserIdVerification.id_front_image_attribute_name]: Image,
      [UserIdVerification.id_back_image_attribute_name]: Image,
      [UserIdVerification.verification_status_attribute_name]: null,
      [UserIdVerification.comments_attribute_name]: null,
      [UserIdVerification.is_submitted_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  isSubmitted() {
    return this.getAttribute(UserIdVerification.is_submitted_attribute_name);
  }
  getVerificationStatus() {
    return this.getAttribute(UserIdVerification.verification_status_attribute_name);
  }
  getVerificationComments() {
    return this.getAttribute(UserIdVerification.comments_attribute_name);
  }
  getFullName() {
    return this.getAttribute(UserIdVerification.full_name_attribute_name);
  }
  getIdFrontImage() {
    return this.getAttribute(UserIdVerification.id_front_image_attribute_name);
  }
  getIdFrontImageUrl() {
    let imageIdFront = this.getIdFrontImage();
    return imageIdFront instanceof Image ? imageIdFront.getImageUrl() : null;
  }
  getIdBackImage() {
    return this.getAttribute(UserIdVerification.id_back_image_attribute_name);
  }
  getIdBackImageUrl() {
    let imageIdBack = this.getIdBackImage();
    return imageIdBack instanceof Image ? imageIdBack.getImageUrl() : null;
  }
}
_defineProperty(UserIdVerification, "VERIFICATION_PENDING_STATUS", 'pending');
_defineProperty(UserIdVerification, "VERIFICATION_REJECTED_STATUS", 'rejected');
_defineProperty(UserIdVerification, "VERIFICATION_VERIFIED_STATUS", 'verified');
_defineProperty(UserIdVerification, "id_attribute_name", 'id');
_defineProperty(UserIdVerification, "user_attribute_name", 'user');
_defineProperty(UserIdVerification, "full_name_attribute_name", 'full_name');
_defineProperty(UserIdVerification, "id_front_image_attribute_name", 'id_front_image');
_defineProperty(UserIdVerification, "id_back_image_attribute_name", 'id_back_image');
_defineProperty(UserIdVerification, "verification_status_attribute_name", 'verification_status');
_defineProperty(UserIdVerification, "comments_attribute_name", 'comments');
_defineProperty(UserIdVerification, "is_submitted_attribute_name", 'is_submitted');